import styled from 'styled-components';
import { Title as FilterTitle, FilterFormTitle } from 'components/Filters/styles';

export const ContentContainer = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const FiltersContainer = styled.div`
  width: 250px;
  margin-right: 20px;

  ${FilterTitle}, ${FilterFormTitle} {
    margin-top: 15px;
  }
`;

export const FilteredTableContainer = styled.div`
  width: 100%;
  max-width: calc(100% - 270px);
`;
